/**
 * This is where the 3rd party get imported and put in the global scope. 
 * 
 * This will be processed individually by Rollup to `web/js/lib-bundle.js`
 * 
 * Keep it .js to make it simple (no need to have type checking on this file)
 * 
 */

window.__version__ = "DROP-028-03";
